import { formatDistance, formatDistanceStrict, formatDistanceToNowStrict, format, isValid, parseISO } from "date-fns";

export const getTimeInStage = (updatedAt: string | null): string => {
  if (!updatedAt) return "New";
  
  try {
    const now = new Date();
    const updatedDate = new Date(updatedAt);
    
    // Calculate the difference in days
    const diffInMs = now.getTime() - updatedDate.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    
    // If more than 30 days, show in months or years
    if (diffInDays > 30) {
      return formatDistanceStrict(updatedDate, now, {
        addSuffix: false,
        unit: diffInDays > 365 ? 'year' : 'month'
      });
    }
    
    // If more than 1 day, show in days
    if (diffInDays >= 1) {
      return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'}`;
    }
    
    // If less than a day, show hours
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    if (diffInHours >= 1) {
      return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'}`;
    }
    
    // If less than an hour
    return '<1 hour';
  } catch (e) {
    return "Unknown";
  }
};

export const formatPostedDate = (dateString?: string | null): string => {
  if (!dateString) return "Date not available";
  
  try {
    const date = parseISO(dateString);
    if (!isValid(date)) {
      // Try to parse if it's already a Date object or a different string format that Date constructor can handle
      const alternativeDate = new Date(dateString);
      if (!isValid(alternativeDate)) {
        return "Invalid date";
      }
      return formatDistanceToNowStrict(alternativeDate, { addSuffix: true });
    }
    
    return formatDistanceToNowStrict(date, { addSuffix: true });
  } catch (e) {
    // console.error("Error formatting date:", e);
    return "Date not available";
  }
};
